<template>
	<div class="row">
		<div class="col-20 transition-fadeinup">

			<h1>Export object</h1>
			<h5><i class="fa fa-exclamation-triangle"></i> Use with caution!</h5>

			<ul class="form">
				<li>
					<ul class="options">
						<li><label><input type="checkbox" class="toggle" checked> Export object-structure</label></li>
						<li><label><input type="checkbox" class="toggle"> Export object data</label></li>
					</ul>
				</li>
				<li><a class="btn"><i class="fa fa-download"></i> Export</a></li>
			</ul>

			<div class="code" data-component="sqlcode">
				<pre class="language-sql">DROP TABLE IF EXISTS `team`;

					CREATE TABLE `team` (
						`id` int(11) unsigned NOT NULL AUTO_INCREMENT,
						`creator` int(11) unsigned NOT NULL DEFAULT '1',
						`created` timestamp NOT NULL DEFAULT '0000-00-00 00:00:00',
						`updated` timestamp NOT NULL DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
						`status` int(11) unsigned NOT NULL DEFAULT '2',
						`name` varchar(255) COLLATE utf8_bin NOT NULL,
						`firstname` varchar(255) COLLATE utf8_bin NOT NULL,
						`function` varchar(255) COLLATE utf8_bin NOT NULL,
						`phone` varchar(255) COLLATE utf8_bin NOT NULL,
						`photo` text COLLATE utf8_bin NOT NULL,
						`offset_right` int(11) unsigned NOT NULL,
						`offset_left` int(11) unsigned NOT NULL,
						PRIMARY KEY (`id`)
					) ENGINE=MyISAM DEFAULT CHARSET=utf8 COLLATE=utf8_bin;

					LOCK TABLES `team` WRITE;
					/*!40000 ALTER TABLE `team` DISABLE KEYS */;

					INSERT INTO `team` (`id`, `creator`, `created`, `updated`, `status`, `name`, `firstname`, `function`, `phone`, `photo`, `offset_right`, `offset_left`)
					VALUES
						(10,3,'2018-02-15 14:01:10','2018-02-19 16:33:59',1,X'4F6E616E',X'526166',X'4163636F756E74616E74',X'303135203333203035203331',X'5B2232303138303232362E3135313334362E356139343136316131323762362E6A7067225D',13,12),
						(3,1,'2016-05-10 16:28:17','2016-06-20 14:26:40',1,X'536368756C7465',X'53746576656E',X'46696E616E6365204469726563746F72',X'303135203333203035203331',X'5B2232303136303631332E3131303833362E353735653738313432663966322E6A706567225D',3,2),
						(4,1,'2016-06-13 12:14:13','2018-02-19 16:33:59',1,X'546F636B',X'5368616E61',X'50726F6A65637420436F6F7264696E61746F72',X'30343835203837203635203433',X'5B2232303138303232362E3135303032382E356139343132666338363266642E6A7067225D',7,6),
						(6,1,'2016-06-13 12:16:23','2018-02-19 16:33:59',1,X'4372C3A9656C6C65',X'52656265636361',X'4D616E6167656D656E7420417373697374616E74',X'3031352F3333203035203331',X'5B2232303136313130382E3131323835362E353832316138653832333639392E6A706567225D',11,10),
						(8,1,'2016-06-22 15:24:54','2018-02-19 16:33:59',1,X'4365756C656D616E73',X'4E69636F',X'546563686E6963616C2044657369676E6572',X'30343932203235203031203132',X'5B2232303136313130382E3131323930382E353832316138663465663432312E6A706567225D',9,8);

					/*!40000 ALTER TABLE `team` ENABLE KEYS */;
					UNLOCK TABLES;
				</pre>
			</div>

		</div>
	</div>
</template>

<script>

export default {
	name: 'export',

	mounted () {

	}
}

</script>
